<template>
  <section
    v-if="$store.state.events.userPayoutsStatus === 'loading'
      || ($route.path.indexOf('/events') !== -1
        && ($store.state.events.eventsStatus === 'loading'
        || $store.state.events.eventStatus === 'loading')
        || $store.state.events.updateTransactionsStatus === 'loading')"
    class="no-transaction">
    <app-loader
      class="loader"
    />
  </section>
  <div v-else :class="['people-list__wrapper', { 'people-list_family-list': doFamiliesDisplay }]">
  <ul class="people-list">
    <draggable
      v-if="isDraggable"
      v-model="finalUsers"
      :group="draggableGroup"
      @sort="humanDrag"
      @end="endDrag"
      chosenClass="dragged-item"
      :force-fallback="true"
      :scroll-sensitivity="100"
      handle=".dragSwitch"
      :move="validateItemMove"
      @change="$emit('updateFamily', finalUsers)"
    >
      <li
        v-for="(user) of (finalUsers && finalUsers.length ? finalUsers : users)"
        :key="user.uid"
        class="human-item"
        @click="onSelect(user)"
      >
        <human-item
          @linkClick="$emit('linkClick')"
          :class="{
            'family-head': user && user.familyHead,
            'family-member': user && user.familyMember
          }"
          @selectUser="(selectedUser) => $emit('selectUser', selectedUser)"
          @deleteUser="(deletedUser) => $emit('deleteUser', deletedUser)"
          @changeMoney="(splitUsersMoney) => $emit('changeMoney', splitUsersMoney)"
          :bordered="(finalUsers.length === 0
            || (finalUsers[users.length - 1]
            && finalUsers[users.length - 1].uid !== user.uid))
          && !user.lastFamilyMember"
          :show-delete-button="(isDeleteButtonShown(user)
            && checkUserEvents(user)
            && isUserUnlocked(user))
          || isDeleteButtonDisabled(user)"
          :disable-delete-button="disabledUserIds.includes(user.uid)"
          :show-drag-icon="showDragIcon"
          :disable-focus="disableFocus"
          :message="message"
          :selected="activeUser.uid === user.uid"
          :user="user"
          :show-event-owner-badge="user.uid === ownerId"
          :show-family-owner-border="familyOwnerIds.includes(user.uid)"
          :currency="currency"
          :show-money-input="showMoneyInput"
          :show-user-phone="showUserPhone"
          :add-link-to-username="(addLinkToUsers) && (user.uid !== $store.state.user.user.user)"
          :even-for-rest-total="evenForRestTotal"
        />
        <family-balances
          v-if="user.lastFamilyMember"
          :balance="familyBalances[user.familyIndex]"
          :currency="currency"
        />
      </li>
    </draggable>
    <li
      v-else
      v-for="(user) of (finalUsers && finalUsers.length ? finalUsers : users)"
      :key="user.uid"
      class="human-item"
      @click="onSelect(user)"
    >
      <human-item
        @linkClick="$emit('linkClick')"
        :class="{
        'family-head': user && user.familyHead,
         'family-member': user && user.familyMember
      }"
        @selectUser="(selectedUser) => $emit('selectUser', selectedUser)"
        @deleteUser="(deletedUser) => $emit('deleteUser', deletedUser)"
        @changeMoney="(splitUsersMoney) => $emit('changeMoney', splitUsersMoney)"
        :bordered="(finalUsers.length === 0
            || (finalUsers.at(-1)
            && finalUsers.at(-1).uid !== user.uid))
          && !user.lastFamilyMember"
        :show-delete-button="(isDeleteButtonShown(user)
            && checkUserEvents(user)
            && isUserUnlocked(user))
          || isDeleteButtonDisabled(user)"
        :disable-delete-button="disabledUserIds.includes(user.uid)"
        :disable-focus="disableFocus"
        :message="message"
        :selected="activeUser.uid === user.uid"
        :user="user"
        :show-event-owner-badge="user.uid === ownerId"
        :show-family-owner-border="familyOwnerIds.includes(user.uid)"
        :currency="currency"
        :show-money-input="showMoneyInput"
        :show-user-phone="showUserPhone"
        :add-link-to-username="(addLinkToUsers) && (user.uid !== $store.state.user.user.user)"
        :even-for-rest-total="evenForRestTotal"
      />
      <family-balances
        v-if="user.lastFamilyMember"
        :balance="familyBalances[user.familyIndex]"
        :currency="currency"
      />
    </li>
    <li
      class="add-participants-list__item_no-item"
      v-if="users && !users.length"
    >
      <img src="../../assets/img/sad.svg" alt="">
      <span class="no-users-text">
        {{ $t('peopleList.noUsers') }}
      </span>
    </li>
    <li v-if="showAddButton">
      <add-human-button
        v-if="$store.state.events.event && !$store.state.events.event.quasi_event_name"
        variant="add"
        @clicked="openAddEventParticipantsForm"
      />
    </li>
  </ul>
  <intersection-observer @intersect="intersected"></intersection-observer>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import HumanItem from '../HumanItem/HumanItem';
import AddHumanButton from '../AddHumanButton/AddHumanButton';
import FamilyBalances from '../FamilyBalances/FamilyBalances';
import AppLoader from '../AppLoader/AppLoader';
import IntersectionObserver from '../IntersectionObserver/IntersectionObserver';

export default {
  name: 'PeopleList',
  components: {
    AppLoader,
    FamilyBalances,
    AddHumanButton,
    HumanItem,
    Draggable,
    IntersectionObserver,
  },
  props: {
    message: {
      type: String,
      default: 'dont show',
      validate: (val) => ['dont show', 'show money', 'show all'].includes(val),
    },
    users: {
      type: Array,
      default: null,
    },
    families: {
      type: Array,
      default: null,
    },
    currency: {
      type: String,
      default: '',
    },
    activeUser: {
      type: Object,
      default: () => ({}),
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    lockUserDeletion: {
      type: Boolean,
      default: false,
    },
    checkUserAmount: {
      type: Boolean,
      default: true,
    },
    checkUserEventsForDelete: {
      type: Boolean,
      default: false,
    },
    activeUsers: {
      type: Array,
      default: () => [],
    },
    ownerId: {
      type: Number,
      default: null,
    },
    familyOwnerId: {
      type: Number,
      default: null,
    },
    familyOwnerIds: {
      type: Array,
      default: () => [],
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    disableFocus: {
      type: Boolean,
      default: false,
    },
    showMoneyInput: {
      type: Boolean,
      default: false,
    },
    showUserPhone: {
      type: Boolean,
      default: false,
    },
    enableAccessCheck: {
      type: Boolean,
      default: true,
    },
    disableDeleteButtonIfAccessDenied: {
      type: Boolean,
      default: false,
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    showDragIcon: {
      type: Boolean,
      default: false,
    },
    draggableGroup: {
      type: String,
      default: '',
    },
    addLinkToUsers: {
      type: Boolean,
      default: false,
    },
    evenForRestTotal: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      familyBalances: [],
      currentFamily: 1,
      doFamiliesDisplay: false,
      usersByFamily: [],
      previousUsersByFamily: [],
      page: 0,
      finalUsers: [],
    };
  },
  computed: {
    disabledUserIds() {
      const users = this.finalUsers && this.finalUsers.length
        ? this.finalUsers : this.users;
      return (users.filter((user) => {
        if (this.disableDeleteButtonIfAccessDenied
          && this.activeUsers.includes(user.uid)
          && this.ownerId === this.$store.state.user.user.user
          && this.ownerId !== user.uid) {
          return true;
        }
        return false;
      }).map((user) => user.uid));
    },
  },
  mounted() {
    try {
      if (this.families && this.users && this.families.length && this.users.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.familyBalances = [];
        const users = this.users.concat();
        const { families } = this;
        let familyUsers = [];
        if (families && families.length) {
          families.forEach((family, familyIndex) => {
            // eslint-disable-next-line no-unused-vars,prefer-const
            let { head, members, balance } = family;
            this.familyBalances.push(balance);
            head = { ...this.getContact(head) };
            head.familyHead = true;
            head.familyIndex = familyIndex;
            const headIndex = users.findIndex((user) => user.uid === head.uid);
            users.splice(headIndex, 1);
            members = members.map((member) => ({ ...this.getContact(member) }));
            members.forEach((familyMember, index) => {
              const member = familyMember;
              member.familyMember = true;
              member.familyIndex = familyIndex;
              if (index === members.length - 1) {
                member.lastFamilyMember = true;
              }
              const memberIndex = users.findIndex((user) => user.uid === member.uid);
              users.splice(memberIndex, 1);
            });
            familyUsers = familyUsers.concat([head, ...members]);
          });
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.doFamiliesDisplay = true;
        this.usersByFamily = [...familyUsers, ...users];
        return;
      }
      this.usersByFamily = this.users;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('could not create people list from provided data: ', e.message);
      this.usersByFamily = [];
    }
  },
  watch: {
    users() {
      this.usersByFamily = this.users;
    },
    usersByFamily() {
      this.page = 1;
      this.finalUsers = this.usersByFamily?.slice(0, 10);
    },
    families() {
      try {
        if (this.families && this.users && this.families.length && this.users.length) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.familyBalances = [];
          const users = this.users.concat();
          const { families } = this;
          let familyUsers = [];
          if (families && families.length) {
            families.forEach((family, familyIndex) => {
              // eslint-disable-next-line no-unused-vars,prefer-const
              let { head, members, balance } = family;
              this.familyBalances.push(balance);
              head = { ...this.getContact(head) };
              head.familyHead = true;
              head.familyIndex = familyIndex;
              const headIndex = users.findIndex((user) => user.uid === head.uid);
              users.splice(headIndex, 1);
              members = members.map((member) => ({ ...this.getContact(member) }));
              members.forEach((familyMember, index) => {
                const member = familyMember;
                member.familyMember = true;
                member.familyIndex = familyIndex;
                if (index === members.length - 1) {
                  member.lastFamilyMember = true;
                }
                const memberIndex = users.findIndex((user) => user.uid === member.uid);
                users.splice(memberIndex, 1);
              });
              familyUsers = familyUsers.concat([head, ...members]);
            });
          }
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.doFamiliesDisplay = true;
          this.usersByFamily = [...familyUsers, ...users];
          return;
        }
        this.usersByFamily = this.users;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('could not create people list from provided data: ', e.message);
        this.usersByFamily = [];
      }
    },
  },
  methods: {
    intersected() {
      this.finalUsers = this.usersByFamily?.slice(0, (this.page + 1) * 10);
      this.page += 1;
    },
    validateItemMove(e) {
      this.$emit('draggedOver', e.to);
      return true;
    },
    endDrag() {
      this.$emit('dragIsOver');
    },
    humanDrag(e) {
      try {
        if (this.ownerId !== this.$store.state.user.user.user) return;
        if (this.usersByFamily?.length) {
          const prevHuman = this.usersByFamily[e.newIndex - 1];
          const current = this.usersByFamily[e.newIndex];
          const currentBefore = { ...current };
          const nextHuman = this.usersByFamily[e.newIndex + 1];
          if (current) {
            if (current.lastFamilyMember) {
              if (this.previousUsersByFamily[e.oldIndex - 1].familyHead) {
                this.previousUsersByFamily[e.oldIndex - 1].familyHead = false;
              } else {
                this.previousUsersByFamily[e.oldIndex - 1].lastFamilyMember = true;
              }
              if (prevHuman && nextHuman
                && prevHuman.familyHead && nextHuman.familyMember
                && !this.usersByFamily[e.newIndex + 2]) {
                nextHuman.lastFamilyMember = true;
                current.lastFamilyMember = false;
              }
              current.lastFamilyMember = false;
              current.familyMember = false;
              current.familyIndex = false;
            }
            if (prevHuman
              && (prevHuman.familyMember || prevHuman.familyHead)
              && !prevHuman.lastFamilyMember) {
              current.familyMember = true;
              current.familyIndex = prevHuman.familyIndex;
            } else if ((prevHuman && prevHuman.lastFamilyMember)
              || (nextHuman && nextHuman.familyHead && !current.lastFamilyMember)) {
              current.familyMember = false;
              current.familyIndex = false;
            } else if ((!prevHuman || (!prevHuman.familyHead && !prevHuman.familyMember))) {
              current.familyMember = false;
              current.familyIndex = false;
            }
          }
          if (currentBefore && current && (!!currentBefore.familyMember !== !!current.familyMember
            || !!currentBefore.familyHead !== !!current.familyHead
            || !!currentBefore.familyIndex !== !!current.familyIndex)) {
            this.saveCurrentFamilies();
          }
          this.$forceUpdate();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('error in families dragsort: ', err.message);
      }
    },
    saveCurrentFamilies() {
      const families = [];
      let head = '';
      let members = [];
      this.usersByFamily.forEach((user) => {
        if (user.familyHead) head = user.phone;
        if (user && user.familyMember) members.push(user.phone);
        if (user.lastFamilyMember) {
          families.push({
            head,
            members,
          });
          head = '';
          members = [];
        }
      });
      this.$emit('updateFamilies', families);
    },
    onSelect(user) {
      this.selected = [];
      this.selected.push(user.uid);
    },
    openAddEventParticipantsForm() {
      this.$bvModal.show('add-event-participants');
    },
    isDeleteButtonDisabled(user) {
      if (this.disableDeleteButtonIfAccessDenied
        && this.activeUsers.includes(user.uid)
        && this.ownerId === this.$store.state.user.user.user
        && this.ownerId !== user.uid) {
        // this.disabledUserIds.push(user.uid);
        return true;
      }
      return false;
    },
    isDeleteButtonShown(user) {
      let show = false;
      if (!this.enableAccessCheck) show = true;
      if (this.enableAccessCheck) {
        if (!this.activeUsers.includes(user.uid)
          && this.ownerId === this.$store.state.user.user.user) {
          show = true;
        }
        if (this.familyOwnerId && user.uid === this.$store.state.user.user.user) {
          show = true;
        }
        if (this.familyOwnerId && this.familyOwnerId === this.$store.state.user.user.user) {
          show = true;
        }
      }
      if (!this.enableAccessCheck && this.checkUserAmount && user.amount !== 0) {
        show = false;
      }
      if (show) {
        return this.showDeleteButton;
      }
      return false;
    },
    isUserUnlocked(user) {
      return !((user.uid === this.$store.state.user.user.user
      || user.user === this.$store.state.user.user.user)
      && this.lockUserDeletion);
    },
    checkUserEvents(user) {
      try {
        if (!this.checkUserEventsForDelete) return true;
        const getPayoutUser = this.$store.state.events.payouts.users.find((payoutUser) => (
          payoutUser.uid === user.uid
        ));
        return !getPayoutUser.events.length;
      } catch (e) {
        return false;
      }
    },
    getContact(id) {
      try {
        const inEventContacts = this.$store.state.events.event.contacts
          .find((contact) => contact.uid === id);
        const inFriends = this.$store.state.user.userContacts.find((contact) => contact.uid === id);
        return inEventContacts || inFriends;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('could not find user ', id);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.people-list__wrapper{
  margin: 0 0 32px;
}
.people-list {
  margin: 0;
  list-style-type: none;
  padding: 0;
  word-break: break-word;
  overflow-y: auto;
  /*-ms-overflow-style: none;  !* IE and Edge *!*/
  /*scrollbar-width: none;  !* Firefox *!*/
  /*&::-webkit-scrollbar {*/
  /*  display: none; !* Chrome, Safari and Opera *!*/
  /*}*/
}

.people-list_family-list {
  margin: 0 0 32px -32px;
  .people-list{
    padding: 0 0 0 32px;
  }
}

.add-participants-list__item_no-item {
  padding: 9px 0 0;
}

.family-head {
  position: relative;
  padding-left: 5px;
  &::after {
    content: "";
    top: 50%;
    right: 100%;
    position: absolute;
    width: 15px;
    height: 55%;
    border-top: 2px solid var(--gray-lighten);
    border-left: 2px solid var(--gray-lighten);
  }
}

.family-member {
  position: relative;
  padding-left: 20px;

  &::after {
    content: "";
    top: 0;
    right: 100%;
    position: absolute;
    width: 15px;
    height: 105%;
    border-left: 2px solid var(--gray-lighten);
  }

  &::before {
    content: "";
    top: 50%;
    right: calc(100% - 15px);
    position: absolute;
    width: 30px;
    height: 50%;
    border-top: 2px solid var(--gray-lighten);
  }
}

.loader {
  margin: 20% auto;
}

.no-users-text {
  font-size: 1rem;
  color: #ABB1CD;
  font-weight: normal;
  margin: 0 0 0 16px;
}

.human-item {
  text-decoration: none;
}

.dragged-item .human-item {
  border: none;
}
</style>
